<template>
    <div>
        <section class="products-list-container ">
            <h1 class="products-list-title">产品列表</h1>
            <ul class="products-type-list">
                <!-- <li>
                    <router-link :to="{ path:'/products/', query: {customerType:customerType} }" exact class="products-type-list--link">全部</router-link>
                    <button class="products-type-list&#45;&#45;link products-btn products-cur" id="all" @click="allClick()">全部
                    </button>
                </li> -->
                <!-- <li >
                    <router-link
                            :to="{ path:'/products/', query: {customerType:1,categoryCode:1003} }"
                            exact style="color:#EB662B;" class="products-type-list--link">
                        全部
                    </router-link>
                </li> -->
            </ul>
            <div class="products-list" ref="productsList">
                <el-row class="products-list__row" :gutter="24">
                    <el-col :span="8" v-for="item in productListData" :key="item.productId">
                        <div tag="div" class="products-list-item" @click="beginApplyLoan(item)">
                            <div class="products-list-item__pic"
                                 :style="{backgroundImage: `url(${imgSrcPrefix}${item.productImg})`}">
                                <div class="products-list-item__pic-warp"></div>
                            </div>
                            <div class="products-list-item__interest-rate"  v-if="item.productClassification == 1">
                                <p>仅对长期合作客户开放</p>
                                <p>折扣利率、资料简化</p>
                                <p>融资比例上限提高</p>
                            </div>
                            <div class="products-list-item__interest-rate"  v-if="item.productClassification == 2">
                                <p></p>
                                <p></p>
                                <p>企业应收转让</p>
                                <p>融资速度快</p>
                            </div>
                            <div class="products-list-item__interest-rate"  v-if="item.productClassification == 3">
                                <p></p>
                                <p></p>
                                <p>买方确权应付</p>
                                <p>利率相对优惠</p> 
                            </div>
                            <div class="products-list-item__interest-rate"  v-if="item.productClassification == 4">
                                <p></p>
                                <p></p>
                                <p>仅对战略合作买方体系开放</p>
                                <p>解决立账期间短时资金需求</p>
                            </div>
                            <div class="products-list-item__interest-rate"  v-if="item.productClassification == 5">
                                <p></p>
                                <p></p>
                                <p>提供票据融资咨询服务</p>
                                <p>多方合作、渠道无忧</p>
                            </div>    
                            <div class="products-list-item__interest-rate"  v-if="item.productClassification == 6">
                                <p></p>
                                <p></p>
                                <p>融资比例100%</p>
                                <p>融资成本较低</p>
                            </div>                                                                                                                                          
                            <div :class="item.productName.length > 6 ? 'products-list-item__title2' : 'products-list-item__title'">{{item.productName}}</div>
                            <!-- <div class="products-list-item__info">
                                <div class="products-list-item__info--content">{{item.productBriefInfo}}</div>
                            </div> -->
                        </div>
                    </el-col>
                </el-row>
                <div class="loading" v-show="isLoading">
                    正在加载...
                </div>
                <div class="noMoreData" v-show="isComplete">
                    没有更多数据了
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import _ from 'lodash';
    import {mapGetters, mapActions, mapMutations} from 'vuex';
    import * as types from './../vuex/types';
    import productsApi from '../api/products.js';
    import loanApi from '../api/myloan_bl';    
    import applyloanApi from '../api/applyloan';
    import api from '../vuex/api';

    export default {
      data () {
        return {
          isLoading: false,
          isComplete: false,
          currentPage: 1,
          currentProductType: this.$route.params.id,
          productListChunk: [],
          customerType: 1,
          productTypeList: '',  // 产品分类类别数据
          productListData: '',  // 产品分类数据
          productListArr: [],  // 产品分类数据
          productListObj: []  // 产品分类数据
        };
      },
      computed: {
        ...mapGetters({
          imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
          userInfo: types.GET_USER
        })

      },
      methods: {
        ...mapActions({
          getProductDetails: types.GET_PRODUCT_DETAILS,
          setAlertMessage: types.SET_FAIL_MESSAGE,
          getApplicationQuota: types.GET_APPLICATION_QUOTA,
          getAvailableAmount: types.GET_AVAILABLE_AMOUNT
        }),
            // 获取列表分类数据
        productsData () {
          const _this = this;
          productsApi.getProductCategoryList({}).then((res) => {
            if (res.rspcode == 1) {
              _this.productTypeList = res.data;
            }
          }).catch((error) => {

          });
        },
            // 初始化产品列表数据
        productsListData () {
          const _this = this;

          productsApi.getProductListData({
            tokenId: localStorage.getItem('dl_tokenId_bl')
          }).then((res) => {
            if (res.rspcode == 1) {
              _this.productListData = res.data.proList;
              _this.productListObj = res.data.proList;
              _this.triggerData();
            }
          }).catch((error) => {

          });
        },
            // 全部allClick
            // allClick() {
            //     var button = document.getElementsByClassName('products-list');
            //     this.listStyle(button);
            //     document.getElementById("all").classList.add('products-cur');//全部样式
            // },
            // 获取类名为products-list的所有dom
            // listStyle(btn) {
            //     for (var i = 0; i < btn.length; i++) {
            //         btn[i].classList.remove('products-cur');
            //     }
            // },
            // triggerList() {

            // },
            // 切换数据
            // triggerData(t, index) {
            //     // .classList.add("cur")
            //
            //     document.getElementById("all").classList.remove('products-cur');//删除全部样式
            //     var button = document.getElementsByClassName('products-list');
            //     this.listStyle(button);
            //     button[index].classList.add('products-cur');
            //     this.$nextTick(function () {
            //         var productListObj = this.productListObj;
            //         this.productListArr =[];
            //         for (var i = 0; i < productListObj.length; i++) {
            //             var item = productListObj[i];
            //             if (item.proCategoryValue == t.proCategoryValue) {
            //                 this.productListArr.push(item);
            //             }
            //         }
            //         this.productListData = this.productListArr;
            //     })
            //
            // },

            // 详情跳转
        detailsRouter (item) {
          const productId = item.productId;
          const categoryCode = item.proCategoryValue;
          const productName = item.productName;
          const customerType = this.$route.query.customerType;
          if (categoryCode == '1003') {
            if (productName.indexOf('供应链') != -1) {
              this.$router.push({
                path: '/factoring/',
                query: {
                  customerType,
                  productId,
                  categoryCode,
                  yanse: 1,
                  productName
                }
              });
            } else {
              this.$router.push({
                path: '/factoring/',
                query: {
                  customerType,
                  productId,
                  categoryCode,
                  yanse: 2,
                  productName
                }
              });
            }
          }else {
            this.$router.push({
              path: '/product/',
              query: {
                customerType,
                productId,
                categoryCode
              }
            });
          }
        },
      beginApplyLoan (item) {
        if(item.productClassification == 5){
          const url = 'https://openbank.pingan.com/brcp/openbank/openapi/h5/index.html#/note-platform/RzgxNzgz/home';
          window.open(url, '_blank');
        }else{
          const productName = item.productName;
          const productId = item.productId;
          if (!_.isEmpty(this.userInfo)) {
              // this.applyLoanBtn.diabled = true
            api.isCurrentUserInBlacklist({// 该接口仅有此处用到，也与state关系不大，暂不考虑放入store，减轻复杂度
              token: this.userInfo.token,
              productId: productId
            }).then((res) => {
              const resData = res.data;
              if (Number(resData.code) === 0) { // 不在黑名单，正常进入流程
                if (productName.includes('供应链')) {
                  this.goBlProcess({productId, yanse: 1, productName});
                } else {
                  if (productName.includes('池保理')) { // 池保理产品
                    loanApi.getPoolItemDetails({ // 详情
                      tokenId: localStorage.getItem('dl_tokenId_bl')
                    }).then((res) => {
                      if (res.code == 2) {
                        _this.setAlertMessage({
                          show: true,
                          content: res.msg
                        });
                      } else if (res.code == 0) {
                        this.$router.push({path: `/loanDetail_bl_pool`});
                      } else {
                          // 未申请过池保理
                        this.goBlProcess({productId, yanse: 2, productName});
                      }
                    });
                  } else {
                    this.goBlProcess({productId, yanse: 2, productName});
                  }
                }
              } else if (Number(resData.code) === 5) { // 未填写个人或企业信息
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                });
                this.$router.push('/personalCenter/MyInfo');
              } else if (Number(resData.code) === 3) { // 未实名验证
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                });
                this.$router.push('/personalCenter/realNameAuth');
              } else if (Number(resData.code) === 2) { // 未添加银行卡
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                });
                this.$router.push('/personalCenter/bankcardInfo');
              } else if (Number(resData.code) === 9) { // 未额度授信
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                });
              } else { // 在黑名单，给出提示
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                });
              }
            }).catch((error) => {
              this.$Error(this, error);
            });
          } else {
            // 没有登录
            this.$router.push('/login');
          }
        }
      },   
        /**
         * 跳转项目流程
         */
        goBlProcess ({productId, yanse, productName}) {
          applyloanApi.getDraftApply(productId).then((res) => {
            if (Number(res.data.code) === 0) {
              const apply = res.data.result; // 草稿项目
              if (!apply) {
                // 跳转项目流程第一步
                this.$router.push({
                  path: `/applyLoan/${productId}/step2_bl`,
                  query: {yanse, productName}
                });
              }

              const query = {
                frontApplyId: apply.frontApplyId,
                isEdit: true,
                yanse,
                productName
              };
              switch (apply.applyState) {
                case 'f1':
                  // 跳转第二步
                  this.$router.push({
                    path: `/applyLoan/${productId}/step3_bak_bl`,
                    query: {
                      ...query,
                      selectedBankcardId: apply.bankAccountId
                    }
                  });
                  break;
                case 'f2':
                  // 跳转第三步
                  this.$router.push({
                    path: `/applyLoan/${productId}/step3_bl`,
                    query: {
                      ...query,
                      selectedBankcardId: apply.bankAccountId
                    }
                  });
                  break;
                case 'f3':
                  // 跳转第四步
                  this.$router.push({
                    path: `/applyLoan/${productId}/step4_bl`,
                    query: {
                      ...query,
                      selectedBankcardId: apply.bankAccountId
                    }
                  });
                  break;
                case 'f4':
                  // 跳转第五步
                  this.$router.push({
                    path: `/applyLoan/${productId}/step5_bl`,
                    query
                  });
                  break;
                default:
                  // 跳转第一步
                  this.$router.push({
                    path: `/applyLoan/${productId}/step2_bl`,
                    query
                  });
                  break;
              }
            } else {
              this.setFailMessage({
                show: true,
                content: res.msg || '数据获取失败'
              });
            }
          }).catch((error) => {
            console.error(error);
            this.setFailMessage({
              show: true,
              content: '网络异常，请稍后再试'
            });
          });
        },        


            // 切换产品数据
        triggerData () {
          const categoryCode = this.$route.query.categoryCode;
          this.$nextTick(function () {
            if (categoryCode) {
              const productListObj = this.productListObj;
              this.productListArr = [];
              for (let i = 0; i < productListObj.length; i++) {
                const item = productListObj[i];
                if (item.proCategoryValue == categoryCode) {
                  this.productListArr.push(item);
                }
              }
              this.productListData = this.productListArr;
            } else {
              this.productListData = this.productListObj;
              return;
            }
          });
        }
      },
      created () {
        this.productsData();
        this.productsListData();
            // this.triggerData();
      },
      destroyed () {

      },
      watch: {
        $route (to, from) {
          this.triggerData();
              //   var categoryCode = this.$route.query.categoryCode;
              // if(this.$route.query.categoryCode){
              //       var productListObj = this.productListObj;
              //     this.productListArr = [];
              //       for (var i = 0; i < productListObj.length; i++) {
              //           var item = productListObj[i];
              //           if (item.proCategoryValue == categoryCode) {
              //               this.productListArr.push(item);
              //           }
              //       }
              //       this.productListData = this.productListArr;
              //   }else {
              //       this.productListData = this.productListObj;
              //       return;
              //   }
        }
      },
      mounted () {
        this.triggerData();
      }
    };
</script>
<style lang="scss">
    .el-col el-col-8 {
        /*margin-bottom: 50px !important;*/
    }

    .products-list-item {
        margin-bottom: 50px;
    }

    .products-list-container {
        width: 1140px;
        margin: 0 auto;
        padding-bottom: 50px;
        text-align: center;
        background: $white;
    }

    .products-list-title {
        padding-top: 54px;
        line-height: 1;
        font-family: 'FZLanTingHei-DB-GBK', 'Microsoft YaHei';
        font-size: 44px;
        color: $lighterTrueBlack;

        &:after {
            content: '';
            display: block;
            margin: 35px auto 0;
            width: 100px;
            height: 2px;
            background: #00C0FF;
        }
    }

    .products-type-list {
        width: 952px;
        /*display: flex;*/
        margin: 49px 0 53px 0;
        @include clear;
        /*justify-content: center;*/

        li {
            width: 16%;
            font-size: 18px;
            float: left;
            /*flex: 1;*/
            /*text-align: center;*/
            border-left: 1px solid #666;
            &:last-of-type {
                border-right: 1px solid #666;
            }
            a {
                color: #666;
                &:hover {
                    color: #00c0ff;
                }
                &.active {
                    color: #00c0ff;
                }
            }

        }
    }

    .products-cur {
        color: #00c0ff;
    }

    .products-btn {
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        &:hover {
            color: #00c0ff;
        }

    }

    /*.products-list__row {*/
    /*margin-bottom: 84px;*/

    /*&:last-child {*/
    /*margin-bottom: 60px;*/
    /*}*/
    /*}*/

    .products-list-item {
        position: relative;
        border: 1px solid $lighterGray;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        cursor: pointer;
        overflow: hidden;

        &:hover .products-list-item__pic-warp {
            display: table-cell;
        }

        &:hover .products-list-item__interest-rate {
            display: table-cell;
        }

        &:hover .products-list-item__pic {
            filter: blur(2.4px);
        }
    }

    .products-list-item__title {
        border-top: 1px solid $lighterGray;
        line-height: 60px;
        font-size: 25px;
        color: black;
        // height: 125px;
        &:before {
            content: '·';
            margin-right: 16px;
            color: #c0c0c0;
        }

        &:after {
            content: '·';
            margin-left: 16px;
            color: #c0c0c0;
        }
    }
    .products-list-item__title2 {
        border-top: 1px solid $lighterGray;
        line-height: 60px;
        font-size: 19px;
        color: black;
        // height: 125px;
        &:before {
            content: '·';
            margin-right: 16px;
            color: #c0c0c0;
        }

        &:after {
            content: '·';
            margin-left: 16px;
            color: #c0c0c0;
        }
    }

    .products-list-item__pic {
        @include resetBFC;
        display: table;
        width: 100%;
        height: 320px;
        overflow: hidden;
        background-color: $lightBlack;
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-border-radius: 3px 3px 0 0;
        -moz-border-radius: 3px 3px 0 0;
        border-radius: 3px 3px 0 0;
    }

    .products-list-item__pic-warp {
        display: none;
        width: 100%;
        height: 250px;
        overflow: hidden;
        background-color: rgba(52, 53, 58, 0.43);
    }

    .products-list-item__interest-rate {
        position: absolute;
        top: 0;
        left: 50px;
        display: none;
        width: 60%;
        margin: 100px auto;
        padding: 20px;
        border: 2px solid $white;
        font-family: 'FZLanTingHei-DB-GBK', 'Microsoft YaHei';
        font-size: 16px;
        line-height: 1.8;
        color: $white;
        text-align: center;
        vertical-align: middle;
    }

    .products-list-item__info {
        display: table;
        width: 100%;
    }

    .products-list-item__info--content {
        //display: table-cell;
        overflow: hidden;
        margin-bottom: 12px;
        padding: 0 75px;
        height: 60px;
        line-height: 20px;
        font-family: 'FZLanTingHei-DB-GBK', 'Microsoft YaHei';
        font-size: 16px;
        color: $lighterTrueBlack;
        text-align: center;
        vertical-align: middle;
    }

    // text-justify没用
    // letter-spacing连最后一个字母都会增加间距，设法去除；不然用:after加上去优雅很多
    .products-list-item__decoration {
        display: block;
        border-top: 1px solid $lighterGray;
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        text-align: center;
        font-family: 'Anders', Arial;
        color: #d1d1d1; // 暂时只有这里用上？

        & span {
            letter-spacing: 18px;
        }
    }

    .loading, .noMoreData {
        color: $extraLightBlack
    }
</style>



// WEBPACK FOOTER //
// Products.vue?1f4d92ca